import { API, APIObject } from '@/shared/plugins/Api/API'
import Store from '@/shared/store'

class Quotas {
  constructor (options) {
    this['fpu-s'] = options['fpu-s'] || null
  }
}

class ProjectQuotas extends APIObject {
  constructor (options) {
    super('QUOTA_MANAGER', options, true)
    const dataplantById = Store.getters.DATAPLANT_BY_ID(this.project_id)

    this.created_at = this.created_at || null
    this.updated_at = this.updated_at || null
    this.updated_by = this.updated_by || null
    this.organization_id = this.organization_id || null
    this.project_id = this.project_id || null
    this.quotas = new Quotas(this.quotas || {})
    this.preallocations = this.preallocations || {}
    this.project_display_name = dataplantById?.display_name || null
  }

  async refresh () {
    const quotas = await this.request({
      method: 'GET',
      url: `v1/projects/${this.project_id}`
    })
    this.assign(quotas)
  }

  // Hook called before saving the object
  // Since we need to send a flattened version of preallocations
  // without changing the current object
  _beforeSave (object) {
    const preallocations = this.flattenPreallocations()
    return {
      ...object,
      preallocations
    }
  }

  async save () {
    return await super.save({
      method: 'PUT',
      url: `v1/projects/${this.project_id}`
    }, true)
  }

  assignPreallocations (preallocations) {
    this.preallocations = preallocations
  }

  flattenPreallocations () {
    return Object.fromEntries(
      Object.entries(this.preallocations).map(([key, value]) => [
        key,
        value.quotas ?? value // use `quotas` if it exists, else keep `value` as-is
      ])
    )
  }

  get totalPreallocatedDpus () {
    return Object.values(this.preallocations).reduce((sum, entry) => sum + (entry.quotas?.['fpu-s'] || 0), 0)
  }
}

class ProjectsQuotas extends API {
  constructor (ID) {
    super(ID, true)
  }

  async list () {
    const data = await this.request({
      method: 'GET',
      url: 'v1/projects'
    })
    return data.map(project => new ProjectQuotas(project))
  }

  async getOne (projectId) {
    const data = await this.request({
      method: 'GET',
      url: `v1/projects/${projectId}`
    })
    return new ProjectQuotas(data)
  }

  async validateNewProject (data = {}) {
    return this.request({
      method: 'POST',
      url: 'v1/projects/validate_new_project',
      data
    })
  }
}

export default ProjectsQuotas
export {
  ProjectQuotas,
  ProjectsQuotas
}
